
// ApiUser.tsx  avec Axios et swr
import axios, { AxiosError } from 'axios';
import { ErrorResponse } from 'react-router-dom';


const API_BASE_URL = import.meta.env.VITE_API;

// Créer une instance axios avec les headers communs
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials:true

});

// // Intercepteur pour ajouter le token à chaque requête
// apiClient.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem('access_token');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => error
//   // (error) => Promise.reject(error)
// );
apiClient.interceptors.response.use(response =>   
  {
    console.log('headerrr new',response?.headers)

    return response
  },   
  async error => {
    console.log("interceptors call here")

    const originalRequest = error.config;    
    const is401 = error.response?.status === 401;    
    const reauth = error.response?.headers['x-reauth'] === 'true';
    console.log("reauth value", reauth)
    console.log("already retrying", !originalRequest._retry)
    console.log("Is401 response value", is401)

    if (is401 && reauth && !originalRequest._retry) 
      {
        originalRequest._retry = true;
        console.log("retry de la requete in process")
        try {       
           return await apiClient(originalRequest);      
          } catch (err) {
               return Promise.reject(err);      
              }    
            }    
        return Promise.reject(error);
        });

// Fonction fetcher pour SWR
export const fetcher = (url: string) => apiClient.get(url).then(res => res.data).catch(errors => errors.data);

// API endpoints POUR recuperer les utilisateurs 
export const getUsersUrl = (companyId: string, applicationId: string) => 
  `/Company/${companyId}/applications/${applicationId}/users`;


//End point pour la suppression des utilisateurs
export const deleteUser = async (companyId: string, applicationId: string, userId: string) => {
  return apiClient.delete(`/Company/${companyId}/applications/${applicationId}/users/${userId}`);
};


//Creation d'un utilisateur
export const addUser = async (
  companyId: string, 
  applicationId: string, 
  userData: { fullName: string; email: string; roles : Array<string> }
): Promise<any> => { 
  try {
    console.log("roles user", userData.roles)
    const response = await apiClient.post(`/Company/${companyId}/applications/${applicationId}/users`, {
      fullName: userData.fullName,
      email: userData.email,
      roles: userData.roles,
      applicationId,
    });
    return response.data; 
  } catch (error) {
    const axiosError = error as AxiosError<ErrorResponse>;
    console.error("Erreur lors de l'ajout de l'utilisateur :", axiosError.response);
    return axiosError.response?.data || { message: "Une erreur inattendue est survenue." };
  }
};
// //Mettre à jour un utilisateur.
// export const updateUser = async (companyId: string, applicationId: string, userId: string, email: string) => {
//   return apiClient.put(`/Company/${companyId}/applications/${applicationId}/users`, { id: userId, email });
// };
// Mettre à jour un utilisateur
export const updateUser = async (companyId: string, applicationId: string, userId: string, userData: { fullName: string }) => {
  return apiClient.put(`/Company/${companyId}/applications/${applicationId}/users/${userId}`, {
    id: userId,
    fullName: userData.fullName
  });
};

//Bloquer un utilisateur
export const lockUser = async (companyId: string, applicationId: string, userId: string) => {
  return apiClient.post(`/Company/${companyId}/applications/${applicationId}/users/locked/${userId}`);
};

//Décbloker un utilisateur. 
export const unlockUser = async (companyId: string, applicationId: string, userId: string) => {
  return apiClient.post(`/Company/${companyId}/applications/${applicationId}/users/unlocked/${userId}`);
};

// Supprimer un Role à un utilisateur:
export const deleteUserRole = async (
  companyId: string,
  applicationId: string,
  userId: string,
  roleName: string
) => {
  try {
    const response = await apiClient.delete(
      `/Company/${companyId}/applications/${applicationId}/users/${userId}/role/${roleName}`
    );
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ErrorResponse>;
    console.error("Erreur lors de la suppression du rôle :", axiosError.response);
    throw axiosError;
  }
};

// Ajouter un rôle à un utilisateur
export const addUserRole = async (
  companyId: string,
  applicationId: string,
  userId: string,
  roleName: string
) => {
  try {
    console.log("role tiot add", roleName);

    const response = await apiClient.post(
      `/Company/${companyId}/applications/${applicationId}/users/${userId}/role`,roleName,{
        data : roleName,
        headers : {
          "Content-Type" : 'application/json'
        }
      }
     
    );
   
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ErrorResponse>;
    console.error("Erreur lors de l'ajout du rôle :", axiosError.response);
    throw axiosError;
  }
};

